import {
  GET_TRANSFER_HISTORY_REQUEST,
  GET_TRANSFER_HISTORY_SUCCESS,
  GET_TRANSFER_HISTORY_ERROR,
  REMOVE_TRANSFER_HISTORY,
  GET_CRYPTO_HISTORY_REQUEST,
  GET_CRYPTO_HISTORY_SUCCESS,
  GET_CRYPTO_HISTORY_ERROR,
  REMOVE_CRYPTO_HISTORY,
} from "../../ActionTypes/TransHistoryActionTypes.js";

const initialState = {

  loading: false,
  data: null,
  error: null,

  cryptoHistory: {
    loading: false,
    data: null,
    error: null,
  },
  isFirstLoad: true
};

const TransferHistoryReducer = (state = initialState, action) => {
  switch (action.type) {
    // Transfer History cases
    case GET_TRANSFER_HISTORY_REQUEST:
      return { ...state, loading: state.isFirstLoad, error: null };

    case GET_TRANSFER_HISTORY_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: null, isFirstLoad: false };

    case GET_TRANSFER_HISTORY_ERROR:
      return { ...state, loading: false, error: action.payload, isFirstLoad: false };

    case REMOVE_TRANSFER_HISTORY:
      return { ...initialState };

    // Crypto History cases
    case GET_CRYPTO_HISTORY_REQUEST:
      return {
        ...state,
        cryptoHistory: { loading: true, data: null, error: null },
      };

    case GET_CRYPTO_HISTORY_SUCCESS:
      return {
        ...state,
        cryptoHistory: { loading: false, data: action.payload, error: null },
      };

    case GET_CRYPTO_HISTORY_ERROR:
      return {
        ...state,
        cryptoHistory: { loading: false, data: null, error: action.payload },
      };

    case REMOVE_CRYPTO_HISTORY:
      return {
        ...state,
        cryptoHistory: { loading: false, data: null, error: null },
      };

    default:
      return state;
  }
};

export default TransferHistoryReducer;
